import React, { useState, useEffect } from "react";
import MatchCard from "components/common/MatchCard/MatchCard";
import { FreestarIai } from "components/common/Ads/FreestarRails";
import gql from "graphql-tag";
import { ProMatchSummary } from "graphql/queries";
import Role from "components/Filters/filter-types/Role";
import RoleSplit from "components/Filters/filter-types/RoleSplit";
import { MediaQuery } from "@outplayed/responsive";
import { useMatches } from "lib/hooks/api-hooks";
import League from "components/Filters/filter-types/League";
import Team from "components/Filters/filter-types/Team";
import { ROLES } from "lib/role-helpers";
import { ALL_ROLE_OPTIONS, LEAGUE_OPTIONS } from "query-params/filter-options";
import { useGlobal } from "reactn";
import { SvgMiscFiltersIcon } from "@ugitgud/legos/ui/icon/SVG/MiscFiltersIcon";
import { Icon } from "@ugitgud/legos/ui/icon/Icon";

const GET_LATEST_PRO_MATCHES = gql`
  query LiveGameFeed(
    $numMatches: Int!,
    $proLeague: String,
    $role: String) {
    getLatestProMatches(
      numMatches: $numMatches,
      proLeague: $proLeague,
      role: $role) {
      ${ProMatchSummary}
    }
  }
`;
const GET_LATEST_WORLD_MATCHES = gql`
  query LiveGameFeed(
    $isWorlds: Boolean,
    $proLeague: String,
    $role: String) {
    getLatestWorldsMatchList(
      isWorlds: $isWorlds,
      league: $proLeague,
      role: $role) {
      ${ProMatchSummary}
    }
  }
`;

const LiveGameFeed = (props) => {
  const [role, setRole] = useState(ROLES.ALL);
  const [league, setLeague] = useState(LEAGUE_OPTIONS[0].value);
  const [team, setTeam] = useState("all");
  const [getMatches, { data: matchPage, loading: matchPageLoading, error: matchPageError }] =
    useMatches(GET_LATEST_WORLD_MATCHES);
  const world = false;
  const [worldsPromo, setWorldsPromo] = useGlobal("worldsPromo");

  const [fullMatchList, setFullMatchList] = useState([]);
  const onFilterChange = (key, option) => {
    if (key === "role") {
      setRole(option.value);
    } else if (key === "league") {
      setLeague(option.value);
    } else if (key === "team") {
      setTeam(option.value);
    }
  };

  useEffect(() => {
    getMatches({
      variables: {
        isWorlds: worldsPromo,
        role: role === ROLES.ALL ? null : role,
        proLeague: league === LEAGUE_OPTIONS[0].value ? null : league,
      },
    });
  }, [role, league]);

  useEffect(() => {
    if (matchPage) {
      setFullMatchList(Object.values(matchPage)[0]);
    }
  }, [matchPage]);

  if (fullMatchList.length === 0) {
    return (
      <div className="landing_section live-game-feed">
        <div className="header_container">
          <MediaQuery min="TABLET" max="DESKTOP_LARGE">
            <span className="header">
              {worldsPromo ? "WORLDS TRACKER" : <Icon icon={<SvgMiscFiltersIcon />} className="w-[18px] text-[#5C5C8E]" />}
              Filters
            </span>
          </MediaQuery>
          <span className="filter">
            <MediaQuery at="MOBILE_SMALL">
              <div className="flex align-center">
                <RoleSplit value={role} options={ALL_ROLE_OPTIONS} onFilterChange={onFilterChange} />
                {!world && <League value={league} options={LEAGUE_OPTIONS} onFilterChange={onFilterChange} isMobile />}
                {world && <Team value={team} onFilterChange={onFilterChange} isMobile />}
              </div>
            </MediaQuery>
            <MediaQuery min="TABLET" max="DESKTOP_LARGE">
              <div className="flex align-center">
                <RoleSplit value={role} options={ALL_ROLE_OPTIONS} onFilterChange={onFilterChange} />
                {!world && <League value={league} options={LEAGUE_OPTIONS} onFilterChange={onFilterChange} />}
                {world && <Team value={team} onFilterChange={onFilterChange} />}
              </div>
            </MediaQuery>
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="landing_section live-game-feed">
      <div className="header_container">
        <MediaQuery min="TABLET" max="DESKTOP_LARGE">
          <span className="header">
            {worldsPromo ? "WORLDS TRACKER" : <Icon icon={<SvgMiscFiltersIcon />} className="w-[18px] text-[#5C5C8E]" />}{" "}
            <span className="text-[15px] font-bold ml-[6px] mr-[3px]">Filters</span>
          </span>
        </MediaQuery>
        <span className="filter">
          <MediaQuery at="MOBILE_SMALL">
            <div className="flex align-center">
              <RoleSplit value={role} options={ALL_ROLE_OPTIONS} onFilterChange={onFilterChange} />
              {!world && <League value={league} options={LEAGUE_OPTIONS} onFilterChange={onFilterChange} isMobile />}
              {world && <Team value={team} onFilterChange={onFilterChange} isMobile />}
            </div>
          </MediaQuery>
          <MediaQuery min="MOBILE_LARGE" max="DESKTOP_LARGE">
            <div className="flex align-center">
              <RoleSplit value={role} options={ALL_ROLE_OPTIONS} onFilterChange={onFilterChange} />
              {!world && <League value={league} options={LEAGUE_OPTIONS} onFilterChange={onFilterChange} />}
              {world && <Team value={team} onFilterChange={onFilterChange} />}
            </div>
          </MediaQuery>
        </span>
      </div>
      <div className="content_header">
        <div className="header_1 font-Inter text-white font-semibold text-[16px]">Live Feed</div>
        <div className="header_2" style={{ paddingLeft: "52px" }}>
          Pro Player
        </div>
        <div className="header_3" style={{ textAlign: "center", paddingLeft: "2px" }}>
          Matchup
        </div>
        <div className="header_4" style={{ textAlign: "center" }}>
          KDA
        </div>
        <div className="header_5" style={{ paddingLeft: "5px" }}>
          Runes
        </div>
        <div className="header_6" style={{ textAlign: "center" }}>
          {" "}
          Summoners
        </div>
        <div className="header_7" style={{ textAlign: "center" }}>
          Full Item Build
        </div>
        <div className="header_8"></div>
      </div>

      <FreestarIai />
      <div className="content">
        {(fullMatchList || [])
          .filter((m) => m.proInfo.officialName !== "")
          .slice(0, 11)
          .map((match, index) => (
            <React.Fragment key={index}>
              <MatchCard
                key={index}
                index={index}
                type="champion"
                match={match}
                even={index % 2 === 0}
                disableAmplitude
                isLanding
                world={worldsPromo}
              />
            </React.Fragment>
          ))}
      </div>
    </div>
  );
};

export default LiveGameFeed;
